import { PaginationMetadata } from '../types/pagination';
import { SortOrder } from '../types/userActionRecord';

export const paginationOptions: Array<{ value: number; label: string }> = [
  {
    value: 10,
    label: '10',
  },
  {
    value: 20,
    label: '20',
  },
  {
    value: 50,
    label: '50',
  },

  {
    value: 100,
    label: '100',
  },
];

export const getSortingIcon = (direction: SortOrder) => {
  return direction === SortOrder.DESC ? 'arrow-down' : 'arrow-up';
};

export function generateMeta(page: number, perPage: number, total: number = 0) {
  const meta: PaginationMetadata = {
    total,
    per_page: perPage,
    current_page: total > 0 ? page : 0,
    last_page: Math.ceil(total / perPage),
    first_page: total > 0 ? 1 : 0,
  };

  return meta;
}
